const state = {

    Offers : []
    
  }
  
  const mutations = {
    SetOffers(state, payload){
        state.Offers = payload
    },
    SetIndividualOffers(state, payload){
        state.Offers.push(payload)
    },
    UpdateIndividualOffers(state, payload){

        let index = state['Offers'].findIndex(x => x["_id"] == payload["_id"])
        state['Offers'].splice(index,1,payload)
    },
    DeleteIndividualOffers(state, payload){

        let index = state['Offers'].findIndex(x => x["_id"] == payload["Offer_Id"])
        state['Offers'].splice(index,1)
    }

  }
  
  const actions = {
    
  }
  
  const getters = {

    GetOffers(state){

        return state.Offers
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  